import React from "react"
import PropTypes from "prop-types"

import styles from "../Loader.css"

const LocalLoader = ({ message }) => (
  <div className={styles.root}>
    <div className={[styles.loader, styles.local].join(" ")} />
    {message && (
      <div className={[styles.message, "p-t-10", "fs-12", "c-motive--dark"].join(" ")}>
        {message}
      </div>
    )}
  </div>
)

LocalLoader.propTypes = {
  message: PropTypes.string,
}
LocalLoader.defaultProps = {
  message: null,
}

export default LocalLoader



// WEBPACK FOOTER //
// ./src/shared/components/Loader/Local/LocalLoader.js